// Page
const Listpage = () => import('@/views/content-management/page')
const Formpage = () => import('@/views/content-management/page/form')

export default {
    path: 'page',
    redirect: '/page',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'page',
            component: Listpage,
            meta: {
                link: 'page',
                breadcrumb: [
                    { title: 'Content Management', active: true },
                    { title: 'Page', active: true },
                ],
                pageTitle: 'Page'
            }
        },
        // {
        //     path: 'add',
        //     name: 'addpage',
        //     component: Formpage,
        //     meta: {
        //         link: 'page',
        //         breadcrumb: [
        //             { title: 'Content Management', active: true },
        //             { title: 'Page', url: '/page' },
        //             { title: 'Create', active: true },
        //         ],
        //         pageTitle: 'Create Page'
        //     }
        // },
        {
            path: 'edit/:id',
            name: 'editpage',
            component: Formpage,
            meta: {
                link: 'page',
                breadcrumb: [
                    { title: 'Content Management', active: true },
                    { title: 'Page', url: '/page' },
                    { title: 'Edit', active: true },
                ],
                pageTitle: 'Edit Page'
            }
        }
    ]
}